import React, { useEffect, useRef } from "react";


export default function FencePreviewMap({ polylinePath, polygonPath }) {
  const mapDivRef = useRef(null);
  const mapInstance = useRef(null);
  const overlaysRef = useRef([]);

  const clearOverlays = function () {
    overlaysRef.current.forEach(function (o) {
      o.setMap(null);
    });
    overlaysRef.current = [];
  };

  useEffect(() => {
    if (!polylinePath || !polylinePath.length) {
      clearOverlays();
      return;
    }

    const init = () => {
      if (!mapDivRef.current || !window.google?.maps) {
        setTimeout(init, 150);
        return;
      }

      if (!mapInstance.current) {
        mapInstance.current = new window.google.maps.Map(mapDivRef.current, {
          center: { lat: -23.55, lng: -46.63 },
          zoom: 11,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        });
      } else {
        window.google.maps.event.trigger(mapInstance.current, "resize");
      }

      clearOverlays();

      const polyline = new window.google.maps.Polyline({
        path: polylinePath,
        geodesic: true,
        strokeColor: "#4285F4",
        strokeOpacity: 1,
        strokeWeight: 4,
        map: mapInstance.current,
      });
      overlaysRef.current.push(polyline);

      const bounds = new window.google.maps.LatLngBounds();
      polylinePath.forEach((p) => bounds.extend(p));

      if (polygonPath && polygonPath.length) {
        const polygon = new window.google.maps.Polygon({
          paths: polygonPath,
          strokeColor: "#f97316",
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: "#f97316",
          fillOpacity: 0.18,
          map: mapInstance.current,
        });
        overlaysRef.current.push(polygon);
        polygonPath.forEach((p) => bounds.extend(p));
      }

      mapInstance.current.fitBounds(bounds);
    };

    setTimeout(init, 250);
  }, [polylinePath, polygonPath]);

  useEffect(() => {
    return () => {
      clearOverlays();
      mapInstance.current = null;
    };
  }, []);

  return <div ref={mapDivRef} style={{ width: "100%", height: "100%" }} />;
}
